import React, { useMemo } from 'react';
import AnimatedElement from '../components/AnimatedElement.js';

const ExperienceSection = () => (
<section
  id="experience"
  className="min-h-screen w-full flex flex-col md:flex-row items-stretch p-0 md:p-0 bg-brand-black overflow-visible lg:h-screen lg:overflow-hidden"
>     <div className="w-full md:w-1/2 flex flex-col justify-center h-full py-10 md:py-0">
        <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-[18px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}>                <p className="block justify-center" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    lineHeight: "2",}}>
                    
                پس از فارغ التحصیلی در رشته آمار از دانشگاه شهیدبهشتی تهران ، مسیر حرفه ای خود را بصورت فریلنس آغاز کردم و با استارتاپها ، شتاب دهنده ها ، برندهای دیجیتال و کسب و کارهای مختلف همکاری داشته ام                    
                </p>
                </AnimatedElement>
                <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-[18px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}> 
  
                <p className="block justify-center" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    lineHeight: "2",}}>
                    
                بعد از حدود 10 سال ، امروز تمرکز من بعنوان برندینگ بر درک ماهیت برند ، ساختاردهی هویت و رفتار برند و همراهی تیم ها در مسیر ساخت برندهای منسجم و قابل رشد است ، درکنار این مسیر ، به صورت مستمر روی توسعه سواد برندینگ و تبدیل آن به روشهای عملی کار کرده ام.                    
                    </p>

                    </AnimatedElement>
                    <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-[18px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}> 

                <p className="block justify-center" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    lineHeight: "2",}}>
                    
                اعتقاد دارم قدرت واقعی پروژه ها در نوع همکاری و شبکه ای است که آنها را پیش می برد ، جایی که تخصص فریلنسرها و انرژی نسل جدید می تواند مسیرهای تازه ای بر خلق ارزش ایجاد کند                     
                    
                    </p>

            </AnimatedElement>
            </div>
            <div className="w-full md:w-1/2 mt-12 md:mt-0 md:pl-16 pb-3">
            <div className="relative mb-8">
    <img src="./assets/img/ax-site-final5.png" className="p-0 m-0  w-full h-full object-cover  object-left hidden md:block w-full h-auto" />
    

  </div>
</div>
</section>
);

  


export default ExperienceSection;
